<template>
  <avs-card>
    <template v-slot:title>
      {{ $t("categories.incoming_tasks.name") }}
    </template>
    <template v-slot:content>
      <v-card-text v-if="!isEmpty">
        <avs-list>
          <v-list-item-group>
            <avs-card
              class="mb-2"
              outlined
              v-for="(task, idx) in dataset"
              :key="idx"
              :set="(icon = getIcon(task))"
              @click="handleItemClick(task)"
            >
              <template v-slot:title>
                <div
                  style="width: 100%"
                  class="d-flex justify-space-between"
                >
                  <v-card-title class="pb-0 pl-0 pt-0 primary--text text-h6 font-weight-bold">
                    {{ task.name }}
                  </v-card-title>
                  <component :is="handleStatusComponent(task)" />
                </div>
              </template>
              <template v-slot:content>
                <v-card-text class="pt-0 primary--text text-body-1">
                  <div class="d-flex flex-column">
                    <span>
                      {{
                        $t("commons.from_to", {
                          start_date: toDate(task.start_date),
                          end_date: toDate(task.deadline)
                        })
                      }}
                    </span>
                    <span
                      >{{ $t("categories.project.activity") }} : <b>{{ task.step.name }}</b></span
                    >
                    <span
                      >{{ $tc("categories.project.name", 1) }} :
                      <b>{{ task.project.name }}</b></span
                    >
                    <span
                      >{{ $t("categories.company.name") }} :
                      <b>{{ task.project.company.name }}</b></span
                    >
                  </div>
                </v-card-text>
              </template>
            </avs-card>
          </v-list-item-group>
        </avs-list>
      </v-card-text>

      <v-card-text v-else>{{ $t("messages.information.no_task_display") }}</v-card-text>
    </template>
  </avs-card>
</template>

<script>
import { isDateBefore, toDate, toTimestamp } from "@/utils/datetime"
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"

export default {
  name: "RemainingTasks",
  components: {
    Closed,
    Ongoing,
    Overdue,
    Pending,
    AvsList: () => import("@/components/generics/general/AvsList.vue")
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  computed: {
    dataset() {
      // Filter / Sort data by reversed deadline
      let dataset = this.maxLength > 0 ? this.tasks.slice(0, this.maxLength) : this.tasks
      dataset.sort((a, b) => toTimestamp(a.deadline) - toTimestamp(b.deadline))
      return dataset
    },
    isEmpty() {
      return this.tasks.length <= 0
    }
  },
  methods: {
    toDate,
    getIcon(item) {
      if (isDateBefore(item.deadline)) return { value: "mdi-alert", color: "error" }
      return { value: "mdi-information", color: "primary" }
    },
    handleItemClick(item) {
      this.$store.commit("app/setProject", item.project)
      this.$store.commit("app/setCompany", item.project.company)
      this.$router.push({ name: "Project" })
    },
    handleStatusComponent(task) {
      return task.status
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item:not(:first-child) {
  border-top: solid 1px #999;
}
</style>
